import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el Mega Pack después de comprar?',
  a: 'Recibirás el acceso al material de forma inmediata para que puedas empezar a usarlo el mismo día, sin esperas ni trámites. Todo llega en formato PDF listo para imprimir o proyectar.'
}, {
  q: '¿Para qué nivel educativo está pensado?',
  a: 'El sistema cubre desde el primer año de secundaria hasta el último año de bachillerato y escuelas técnicas. Cada tomo tiene actividades y evaluaciones graduadas por nivel para que puedas adaptarlo a cualquier grupo.'
}, {
  q: '¿Sirve para cualquier país hispanohablante?',
  a: 'Sí. El sistema fue diseñado específicamente para los currículos de 15 países de América Latina: Argentina, México, Perú, Chile, Colombia, Bolivia, Paraguay, Uruguay, Ecuador, El Salvador, Honduras, Guatemala, Costa Rica, República Dominicana y Panamá. Incluye una tabla de equivalencias curriculares para que sepas exactamente qué tomo y unidad corresponde al programa oficial de tu país.'
}, {
  q: '¿El material es editable?',
  a: 'Los tomos se entregan en formato PDF listo para usar, proyectar o imprimir. El formato garantiza que el diseño y el contenido se vean correctamente en cualquier dispositivo.'
}, {
  q: '¿En qué moneda voy a pagar?',
  a: 'Pagas en tu moneda local. El sistema detecta automáticamente tu país y convierte el precio al equivalente de USD 19,90 en pesos argentinos, pesos mexicanos, soles peruanos, pesos colombianos y demás monedas de la región.'
}, {
  q: '¿Qué incluye el Mega Pack Maestro Avanzado?',
  a: 'Incluye todo el Mega Pack (6 tomos + 4 bonos) más el material de nomenclatura de complejos, química de coordinación y la guía Digital Chemistry con simuladores, apps y herramientas de inteligencia artificial para el aula.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tenés 7 días desde la compra para revisar todo el material. Si no te convence por cualquier motivo, escribinos y te devolvemos el 100% de tu dinero. Sin preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-petrol" data-id="element-79">
      <div className="max-w-3xl mx-auto" data-id="element-80">
        <div className="text-center mb-16" data-id="element-81">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white" data-id="element-82">
            ❓ Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-83">
          {faqs.map((faq, index) => <div key={index} className="bg-night-card border border-night-border rounded-xl overflow-hidden" data-id="element-84">
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-85">
                <span className="font-bold text-lg text-white pr-8" data-id="element-86">
                  {faq.q}
                </span>
                <ChevronDown className={`text-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-87" />
              </button>

              <AnimatePresence data-id="element-88">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-89">
                    <div className="px-6 pb-5 text-gray-300 border-t border-night-border/50 pt-4" data-id="element-90">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}